import { range } from 'lodash';
import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import Table from '@splunk/dashboard-visualizations/Table';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import FixSizeExampleCode from '!!raw-loader!./examples/FixSize';
import RowNumberCode from '!!raw-loader!./examples/RowNumber';
import NumberFormatCode from '!!raw-loader!./examples/NumberFormat';
import OverlayCode from '!!raw-loader!./examples/Overlay';
import SparklineCode from '!!raw-loader!./examples/Sparkline';
import RequestParamsCode from '!!raw-loader!./examples/RequestParams';
import CustomCellRendererCode from '!!raw-loader!./examples/CustomCellRenderer';
import ShowHeaderCode from '!!raw-loader!./examples/ShowHeader';
import HeaderBackgroundColorCode from '!!raw-loader!./examples/HeaderBackgroundColor';
import HeaderTextColorCode from '!!raw-loader!./examples/HeaderTextColor';
import RowBackgroundColorCode from '!!raw-loader!./examples/RowBackgroundColor';
import RowTextColorCode from '!!raw-loader!./examples/RowTextColor';

import BasicExample from './examples/Basic';
import FixSizeExample from './examples/FixSize';
import RowNumberExample from './examples/RowNumber';
import NumberFormatExample from './examples/NumberFormat';
import OverlayExample from './examples/Overlay';
import SparklineExample from './examples/Sparkline';
import RequestParamsExample from './examples/RequestParams';
import CustomCellRendererExample from './examples/CustomCellRenderer';
import ShowHeaderExample from './examples/ShowHeader';
import HeaderBackgroundColorExample from './examples/HeaderBackgroundColor';
import HeaderTextColorExample from './examples/HeaderTextColor';
import RowBackgroundColorExample from './examples/RowBackgroundColor';
import RowTextColorExample from './examples/RowTextColor';
import doc from './definition';
import optionsSchema from '../optionsSchema';

function TableDoc() {
    return (
        <VisualizationDocPage
            title="Table"
            description="This visualization has been upgraded in @splunk/visualizations/Table and may be used in UDF."
            examplesSection={[
                <DocExample
                    title="Basic Table"
                    key="basic_table"
                    description="Table takes 100% width by default"
                    code={BasicExampleCode}
                    example={BasicExample}
                />,
                <DocExample
                    title="Fix Size Table"
                    key="fix_size_table"
                    description="Fix size table will be rendered when providing width and height"
                    code={FixSizeExampleCode}
                    example={FixSizeExample}
                />,
                <DocExample
                    title="Update RequestParams"
                    key="request_params"
                    description="Click on paginator or header will update the RequestParams via onRequestParamsChange callback"
                    code={RequestParamsCode}
                    example={RequestParamsExample}
                />,
                <DocExample
                    title="Show row numbers"
                    key="row_numbers"
                    code={RowNumberCode}
                    example={RowNumberExample}
                />,
                <DocExample
                    title="Number Formatting"
                    key="number_formatting"
                    description="Formatting options can be applied to numerial cell"
                    code={NumberFormatCode}
                    example={NumberFormatExample}
                />,
                <DocExample
                    title="Data Overlay"
                    key="data_overlay"
                    code={OverlayCode}
                    example={OverlayExample}
                />,
                <DocExample
                    title="Sparkline"
                    key="sparkline"
                    code={SparklineCode}
                    example={SparklineExample}
                />,
                <DocExample
                    title="Custom Cell renderer"
                    key="custom_cell_renderer"
                    code={CustomCellRendererCode}
                    example={CustomCellRendererExample}
                />,
                <DocExample
                    title="Hide table header"
                    key="show_header"
                    code={ShowHeaderCode}
                    example={ShowHeaderExample}
                />,
                <DocExample
                    title="Set header background color"
                    key="header_background_color"
                    code={HeaderBackgroundColorCode}
                    example={HeaderBackgroundColorExample}
                />,
                <DocExample
                    title="Set header text color"
                    key="header_text_color"
                    code={HeaderTextColorCode}
                    example={HeaderTextColorExample}
                />,
                <DocExample
                    title="Set background color for alternating rows"
                    key="row_background_color"
                    code={RowBackgroundColorCode}
                    example={RowBackgroundColorExample}
                />,
                <DocExample
                    title="Set text color for alternating rows"
                    key="row_text_color"
                    code={RowTextColorCode}
                    example={RowTextColorExample}
                />,
            ]}
            optionSection={<OptionsDoc options={optionsSchema} />}
            eventSection={
                <EventsDoc
                    events={doc.events}
                    Visualization={Table}
                    dsState={{
                        primary: {
                            requestParams: { offset: 0, count: 20 },
                            data: {
                                fields: [{ name: 'foo' }, { name: 'bar' }],
                                columns: [range(5), range(5)],
                            },
                            meta: { totalCount: 100 },
                        },
                    }}
                />
            }
        />
    );
}

export default TableDoc;
